import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent, ResetPasswordFormComponent, CreateAccountFormComponent, ChangePasswordFormComponent } from './shared/components';
import { AuthGuard } from './core/guards/auth.guard';
import { NoAuthGuard } from './core/guards/no-auth.guard';
import { DxDataGridModule, DxFormModule } from 'devextreme-angular';
import { ValidateUserComponent } from './shared/components/validate-user/validate-user.component';


const routes: Routes = [
  {
    path: 'inicio',
    loadChildren: () => import('./pages/inicio/inicio.module').then(m => m.InicioModule),
    //canActivate: [ AuthGuard ]
  },
  {
    path: 'Certificados',
    loadChildren: () => import('./pages/certificado/certificado.module').then(m => m.CertificadoModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'avisosEmail',
    loadChildren: () => import('./pages/avisosEmail/avisosEmail.module').then(m => m.avisosEmailModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'Configuracion',
    loadChildren: () => import('./pages/configuracion/configuracion.module').then(m => m.configuracionModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'reset-password',
    component: ResetPasswordFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'create-account',
    component: CreateAccountFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'change-password/:email/:recoveryCode',
    component: ChangePasswordFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'validate-user/:recoveryCode',
    component: ValidateUserComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: '**',
    redirectTo: 'login-form',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxFormModule
  ],
  providers: [],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
